import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import { fireTag } from '../../libs/analytics.js';


import heroMobileImage from '../../images/articles/P00124182_WF_BRAND_1HFY24ISF_Art10_767x577.jpg';
import heroDesktopImage from '../../images/articles/P00124182_WF_BRAND_1HFY24ISF_Art10_1164x584.jpg';

import ModalOverlay from "../../components/ModalOverlay";


const Shift = ({
				   handleEvent,
				   modalOverlay,
				   closeExitOverlay,
				   addExitClickListeners,
			   }) => {

	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const [gridVisible, setGridVisible] = useState(false);
	const heroOGImage = 'P00124182_WF_BRAND_1HFY24ISF_Art10_ogimage.jpg';

	addExitClickListeners();

	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}


	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				fireTag('A2',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});

				window.setTimeout(() => {
					// console.log(' ======== ');
					// console.log(targetElement);
					targetElement.focus();
				}, 1000);

			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}


	useEffect(() => {

		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)
		linkDisclosures();

	}, []); // empty array says only use this effect once

	let mastheadImage;

	switch (true) {
		case (window.innerWidth < 768):
			mastheadImage = heroMobileImage;
			break;
		case (window.innerWidth < 1440):
			mastheadImage = heroDesktopImage;
			break;
		case (window.innerWidth >= 1440):
			mastheadImage = heroDesktopImage;
			break;
	}
	// console.log(mastheadImage);
	// console.log(process.env.PUBLIC_URL);

	return (
		<>
			<Helmet>
				<title>Making the shift to EVs is getting more affordable </title>
				<meta
					name="description"
					content="Wells Fargo supports customers who want to get behind the wheel of cleaner, more sustainable transportation. "
				/>
				<meta property="og:title" content="Making the shift to EVs is getting more affordable "/>
				<meta
					property="og:description"
					content="Wells Fargo supports customers who want to get behind the wheel of cleaner, more sustainable transportation. "
				/>
				<meta property="og:image" content="https://welcome.wf.com/impact/images/articles/P00124182_WF_BRAND_1HFY24ISF_Art10_ogimage.jpg"/>

				<meta property="twitter:title" content="Making the shift to EVs is getting more affordable "/>
				<meta
					property="twitter:description"
					content="Wells Fargo supports customers who want to get behind the wheel of cleaner, more sustainable transportation. "
				/>
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}
			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>
			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}

			<main className='flex-container'>

				<div className="flex-row">
					{/*flex-col-md-8*/}
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
							Making the shift to EVs is getting more affordable
						</h1>
						<h2 className="summary">
							Wells Fargo supports customers who want to get behind the wheel of cleaner, more sustainable transportation.
						</h2>
					</div>

				</div>

				<div className="flex-row full-width-md ">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="A mother and her son plug in an electric vehicle. "/>
					</div>
				</div>

				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro info-graphic">
						<div className="by-line">
							<p>By Tanya Sanders, <span>head of Auto at Wells Fargo</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>April 16, 2024</p>
							</div>
							<div>
								<p>4-minute read</p>
							</div>
						</div>

						<p>Electric vehicle ownership is becoming a real possibility for more drivers as cleaner transportation gets more affordable. In 2023, more than 1.4 million electric vehicles, or EVs, were <a onClick={()=>fireTag('A1','sold')} target="_blank" href="https://www.energy.gov/articles/statement-us-energy-secretary-jennifer-m-granholm-2023-ev-sales#:~:text=%22Today%2C%20I%27m%20delighted,million%20EVs%20on%20the%20road. " data-click-listener="true" rel="noreferrer">sold</a> in the U.S. — a surge of 50% in one year.
						</p>


						<p>The EV transition may get another boost as the Environmental Protection Agency, or EPA, tightens vehicle emissions standards. The <a onClick={()=>fireTag('A1','rules')} target="_blank" href="https://www.epa.gov/regulations-emissions-vehicles-and-engines/final-rule-multi-pollutant-emissions-standards-model " data-click-listener="true" rel="noreferrer">rules</a> for vehicles starting with model year 2027 require vehicle manufacturers to limit the amount of greenhouse gases produced from cars, SUVs, and pickups, and could spur automakers to produce more hybrids and EVs to meet the requirements.
						</p>


						<p>With more than 50 years of auto-lending experience, Wells Fargo understands that some drivers are <a onClick={()=>fireTag('A1','attracted')} target="_blank" href="https://www.energy.gov/articles/correcting-record-about-electric-vehicle-sales#:~:text=Reality%3A%20Consumer%20interest%20in%20electric,and%20a%20growing%20charging%20infrastructure." data-click-listener="true" rel="noreferrer">attracted</a> to EVs primarily due to environmental and financial concerns. The bank works with a network of nearly 10,000 dealerships that financed more than 100,000 EV loans nationwide last year.
						</p>


						<h2 className="subhead">EV education is a two-way street</h2>


						<p>Since 2021, in collaboration with plug-in vehicle advocacy group <a onClick={()=>fireTag('A1','plug in america')} target="_blank" href="https://pluginamerica.org/" data-click-listener="true" rel="noreferrer">Plug In America</a> (PIA), Wells Fargo has been raising awareness and educating consumers about the benefits of EV ownership through community events. These interactions give drivers an opportunity to get behind the wheel of an EV and get expert answers to their questions.
						</p>

						<p>PIA also gathers reactions from EV owners and potential owners. The nonprofit conducts a <a onClick={()=>fireTag('A1','survey')} target="_blank" href="https://pluginamerica.org/survey/2023-ev-driver-survey/" data-click-listener="true" rel="noreferrer">survey</a> each year to understand the state of mind among EV drivers. The most recent survey shows high satisfaction among owners, with 90% of participants likely to purchase another EV as their next vehicle.
						</p>

						<h2 className="subhead">Lower sales prices can steer new drivers to EVs</h2>

						<p>The purchase price of EVs is going down. From February 2023 to February 2024, EV <a onClick={()=>fireTag('A1','prices fell')} target="_blank" href="https://www.kbb.com/car-news/new-car-prices-dropping-slowly-steadily/" data-click-listener="true" rel="noreferrer">prices fell</a> 12.8%, with an average price of $52,314. However, EVs are still more expensive than comparable gas-powered vehicles.</p>

						<p>A Gallup <a onClick={()=>fireTag('A1','poll')} target="_blank" href="https://news.gallup.com/poll/474095/americans-not-completely-sold-electric-vehicles.aspx" data-click-listener="true" rel="noreferrer">poll</a> found American households with annual incomes of $100,000 and over are more likely to purchase an EV than lower income groups. PIA says this trend is driven by two main factors — the modest number of used EVs on the market and limited access to low-cost home charging. More than 45% of EV owners consider inexpensive charging options before purchase.
						</p>

						<p>While PIA’s EV driver survey found early adopters tend to skew toward higher income brackets, there is a growing recognition of the need to make EVs accessible to a broader range of consumers. In addition to providing access to financing for EVs, Wells Fargo works with dealers in their network and the Military Warriors Support Foundation to award veterans with payment-free EVs or hybrids through their veteran vehicle donation program.</p>

						<h2 className="subhead">EV owners can save money up front and down the road</h2>

						<p>Incentives in the Inflation Reduction Act, or IRA, can help address affordability challenges. The IRA tax credits for qualifying vehicles and home energy improvements aim to make EV ownership more accessible to consumers.</p>

						<p>Dealers can offer qualifying EV <a onClick={()=>fireTag('A1','tax credit')} target="_blank" href="https://www.irs.gov/clean-vehicle-tax-credits" data-click-listener="true" rel="noreferrer">tax credit</a> savings to consumers at the point of sale to reduce the sales price by the credit amount. This can allow buyers to see savings of up to $7,500 instantly, rather than waiting until filing their tax returns. Many states also offer <a onClick={()=>fireTag('A1','additional rebates')} target="_blank" href="https://www.irs.gov/clean-vehicle-tax-credits" data-click-listener="true" rel="noreferrer">additional rebates</a> and tax deductions. The <a onClick={()=>fireTag('A1','rules')} target="_blank" href="https://www.kiplinger.com/taxes/ev-tax-credit-changes-new-years-day" data-click-listener="true" rel="noreferrer">rules</a> for claiming EV tax credits changed for 2024, so drivers should review which vehicles qualify.
						</p>

						<p>The upfront cost is not the only financial factor. PIA found nearly 20% of owners consider the potential cost savings associated with fuel and maintenance. The U.S. Department of Energy <a onClick={()=>fireTag('A1','calculates')} target="_blank" href="https://afdc.energy.gov/vehicles/electric" data-click-listener="true" rel="noreferrer">calculates</a> fuel costs for an internal combustion engine vehicle at $945 a year ($3.06/gallon) compared to $525 a year for an EV ($0.16/kWh).
						</p>


						<p>EV ownership can be an investment in sustainability and personal financial health due to potential savings on annual vehicle expenses. Wells Fargo’s industry-leading experience supports customers who want to purchase EVs while possibly tapping into lower sales prices due to tax incentives and long-term fuel savings. </p>

					</div>


				</div>

				{/*<KonamiElement className="grid"/>*/}
			</main>

			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>
			{/* Adobe retargeting tag */
			}
			{
				/*
					REMOVE TAG
								<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>
				*/
			}

			{
				modalOverlay && modalOverlay.open && (
					<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
				)
			}
		</>
	);
};

export default withRouter(Shift);
